import { createAsyncThunk } from "@reduxjs/toolkit";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import axios from "axios";

export interface District {
  id?: string;
  packageName: string;
  districtCode: string;
  districtName: string;
  state: string;
  status: boolean;
  createBy?: string;
  updatedBy?: string;
  createDate?: string;
  updateDate?: string;
}
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

// const API_URL = "/api/package";
// const API_URL = "https://mastersappbe.kdcstaging.in/api/package";
const API_URL = process.env.REACT_APP_BASE_URL;

export const fetchDistricts = createAsyncThunk(
  "district/fetchDistricts",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              if (typeof filterValue === "object" && filterValue !== null) {
                // Handle cases like { from_date: ..., to_date: ... }
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    params.append(key, String(value));
                  }
                  if (
                    (filterValue.from_date || filterValue.to_date) &&
                    (filterField === "created_at" ||
                      filterField === "updated_at")
                  ) {
                    if (filterField === "created_at") {
                      filterField = "created";
                    } else {
                      filterField = "updated";
                    }
                    params.append("filter_by", filterField);
                  }
                });
              } else {
                // Handle primitive values (string, number)
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      const response: any = await Axios.get(`/district/?${params.toString()}`);

      return {
        data: response.data.data || [],
        rowCount: response.data.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchPackages error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch districts");
    }
  }
);

export const fetchDistrictById = createAsyncThunk(
  "district/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`${API_URL}/district/${id}/get/`);
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch district by ID"
      );
    }
  }
);

export const fetchDistrictsBasedOnSelectedPackage = createAsyncThunk(
  "district/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${API_URL}/block/dropdown/districts/?package_id=${id}`
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch district by ID"
      );
    }
  }
);

export const fetchDistrictByDropDown = createAsyncThunk(
  "package/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/district/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch district list"
      );
    }
  }
);

export const updateDistrict = createAsyncThunk(
  "district/updateDistrict",
  async (packageData: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        `${API_URL}/district/${packageData.id}/update/`,
        packageData
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update district");
    }
  }
);
export const updateStatusInDist = createAsyncThunk(
  "district/updateStatusInDist",
  async (districtData: any, { rejectWithValue }) => {
    try {
      const payload = {
        is_active: districtData.is_active,
      };
      const response: any = await Axios.patch(
        `${API_URL}/district/${districtData.id}/update/`,
        payload
      );

      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update status in district"
      );
    }
  }
);

export const addDistrict = createAsyncThunk(
  "district/addDistrict",
  async (packageData: any, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        `${API_URL}/district/create/`,
        packageData
      );

      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add district");
    }
  }
);

// export const exportDistrictCSV = async () => {
//   const response = await Axios.get("/district/?export=csv", {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "district.csv",
//   };
// };
export const exportDistrictCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (filterField && filterValue !== undefined && filterValue !== null) {
          if (typeof filterValue === "object" && filterValue !== null) {
            Object.entries(filterValue).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                params.append(key, String(value));
              }
              if (
                (filterValue.from_date || filterValue.to_date) &&
                (filterField === "created_at" || filterField === "updated_at")
              ) {
                if (filterField === "created_at") {
                  filterField = "created";
                } else {
                  filterField = "updated";
                }
                params.append("filter_by", filterField);
              }
            });
          } else {
            params.append(filterField, filterValue);
          }
        }
      }
    );
  }

  const response = await Axios.get(`/district/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "district.csv",
  };
};
